export default __webpack_public_path__ + "static/media/raffle-entry.aa6e70c8.gif";